'use strict';

import { view } from '@/functions';

const prefix = '/business-reviews';

export default [
    {
        path: prefix,
        name: 'business-reviews',
        meta: {
            scopes: ['read_business_reviews'],
        },
        component: () => view('business-reviews/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'business-reviews-info',
        meta: {
            scopes: ['read_business_reviews'],
        },
        component: () => view('business-reviews/info'),
    },
];
